import { render } from "./index.vue?vue&type=template&id=63704f14&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=63704f14&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-63704f14"

export default script